import React from 'react';

type StackedTitleProps = {
  lines: Array<{ text: string; highlight?: boolean; className?: string }>;
  sub?: string;
  align?: 'center' | 'left' | 'right';
  color?: string; // Tailwind class for highlight color
};

const StackedTitle: React.FC<StackedTitleProps> = ({
  lines,
  sub,
  align = 'center',
  color = 'text-cyan-500',
}) => {
  const alignCls = align === 'left' ? 'text-left' : align === 'right' ? 'text-right' : 'text-center';
  return (
    <div className={`${alignCls} mb-8 sm:mb-12`}>
      <h2 className="text-4xl sm:text-5xl md:text-6xl font-extrabold text-gray-900 leading-tight">
        {lines.map((l, i) => (
          <span key={i} className={`block ${l.highlight ? `${color} drop-shadow-lg` : ''} ${l.className || ''}`}>
            {l.text}
          </span>
        ))}
      </h2>
      {sub && (
        <p className="text-xl sm:text-2xl text-gray-700 max-w-4xl mx-auto font-medium mt-4">
          {sub}
        </p>
      )}
    </div>
  );
};

export default StackedTitle;


